
import { CLEAR_USER_FORM } from '../constants/actions';

export function clearUserForm() {
  return {
    type: CLEAR_USER_FORM,
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/userForm.actions.js
 **/